import React , {useState} from 'react';
import { images } from '../constants';

const SocialMedia = () => {
  const [isHoveredGFG, setIsHoveredGFG] = useState(false);
  const handleHoverGFG = () => {
    setIsHoveredGFG(!isHoveredGFG);
  };
  const [isHoveredHackerRank, setIsHoveredHackerRank] = useState(false);
  const handleHoverHackerRank = () => {
    setIsHoveredHackerRank(!isHoveredHackerRank);
  };
  const [isHoveredCodeChef, setIsHoveredCodeChef] = useState(false);
  const handleHoverCodeChef = () => {
    setIsHoveredCodeChef(!isHoveredCodeChef);
  };
  const [isHoveredLeetCode, setIsHoveredLeetCode] = useState(false);
  const handleHoverLeetCode = () => {
    setIsHoveredLeetCode(!isHoveredLeetCode);
  };
  const [isHoveredGitHub, setIsHoveredGitHub] = useState(false);
  const handleHoverGitHub = () => {
    setIsHoveredGitHub(!isHoveredGitHub);
  };
  const [isHoveredLinkedIn, setIsHoveredLinkedIn] = useState(false);
  const handleHoverLinkedIn = () => {
    setIsHoveredLinkedIn(!isHoveredLinkedIn);
  };
  const [isHoveredInstagram, setIsHoveredInstagram] = useState(false);
  const handleHoverInstagram = () => {
    setIsHoveredInstagram(!isHoveredInstagram);
  };
return (
  <div className="app__social">
    <a href='https://www.linkedin.com/in/om-singh-8aa95b222/' target="_blank" rel="noreferrer">
      <div onMouseEnter={handleHoverLinkedIn} onMouseLeave={handleHoverLinkedIn}>
        <img src={isHoveredLinkedIn ? images.linkedinwhite : images.linkedblack} alt="LinkedIn" />
      </div>
    </a>
    <a href='https://github.com/omsingh32123' target="_blank" rel="noreferrer">
    <div onMouseEnter={handleHoverGitHub} onMouseLeave={handleHoverGitHub}>
      <img src={isHoveredGitHub ? images.githubwhite : images.githubblack} alt="GitHub" />
    </div>
    </a>
    <a href='https://leetcode.com/Om__Singh__/' target="_blank" rel="noreferrer">
    <div onMouseEnter={handleHoverLeetCode} onMouseLeave={handleHoverLeetCode}>
      <img src={isHoveredLeetCode ? images.leetcodewhite : images.leetcodeblack} alt="LeetCode" />
    </div>
    </a>
    <a href='https://www.codechef.com/users/omsingh32123' target="_blank" rel="noreferrer">
    <div onMouseEnter={handleHoverCodeChef} onMouseLeave={handleHoverCodeChef}>
      <img src={isHoveredCodeChef ? images.codechefwhite : images.codechefblack} alt="CodeChef" />
    </div>
    </a>
    <a href='https://www.hackerrank.com/profile/omsingh32123' target="_blank" rel="noreferrer">
    <div onMouseEnter={handleHoverHackerRank} onMouseLeave={handleHoverHackerRank}>
      <img src={isHoveredHackerRank ? images.hackerrankwhite : images.hackerrankblack} alt="HackerRank" />
    </div>
    </a>
    <a href='https://auth.geeksforgeeks.org/user/omsingh32123/' target="_blank" rel="noreferrer">
    <div onMouseEnter={handleHoverGFG} onMouseLeave={handleHoverGFG}>
      <img src={isHoveredGFG ? images.geeksforgeekswhite : images.geeksforgeeksblack} alt="GFG" />
    </div>
    </a>
    <a href='https://www.instagram.com/_0m_singh_/' target="_blank" rel="noreferrer">
    <div onMouseEnter={handleHoverInstagram} onMouseLeave={handleHoverInstagram}>
      <img src={isHoveredInstagram ? images.instagramwhite : images.instagramblack} alt="Instagram" />
    </div>
    </a>
  </div>
);
}
export default SocialMedia;
